<div
  class="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-100 via-white to-gray-200 p-6"
>
  <div
    class="flex flex-col justify-center items-center h-screen max-h-[800px] w-full max-w-xl bg-white/80 backdrop-blur-lg rounded-3xl shadow-2xl p-8 transition hover:shadow-3xl"
  >
    <h2
      class="text-4xl text-center font-bold text-gray-900 mb-4 tracking-tight"
    >
      🚫 Routini ist derzeit nicht erreichbar.
    </h2>
  </div>
</div>
